import Swiper from 'swiper';
import Animate from "../components/animate";

class PodcastAudioPlayer {
    private sectionsData: {
        desc: string;
        desc_part: string;
        name: string;
        elements: [];
    }[];
    private readonly parentContainer: HTMLElement;
    private items: HTMLElement[];
    private podcastInstance: Swiper;
    private closeButton: HTMLElement;
    private content: HTMLElement;
    private contentTitle: HTMLElement;
    private contentDesc: HTMLElement;
    private infoContainer: HTMLElement;
    private playlistContainer: HTMLElement;
    private inputUrlCopy: HTMLInputElement;
    private btnShareVK: HTMLAnchorElement;
    private btnShareTG: HTMLAnchorElement;
    private btnShareWA: HTMLAnchorElement;
    private btnShareOK: HTMLAnchorElement;

    constructor() {
        // @ts-ignore
        if (typeof SECTIONS === 'undefined') return;
        // @ts-ignore
        this.sectionsData = SECTIONS;

        this.items = Array.from(document.querySelectorAll('.card-cube.swiper-slide'));
        this.infoContainer = document.querySelector('.podcast-slider-container');
        this.playlistContainer = document.querySelector('.podcast-playlist--items');
        this.parentContainer = document.querySelector('.podcast-slider-container > div');
        this.closeButton = document.querySelector('.podcast-close-button');
        this.content = document.querySelector('.podcast-slider-content');
        this.contentTitle = document.querySelector('.podcast-slider-title');
        this.contentDesc = document.querySelector('.podcast-slider-desc');
        this.inputUrlCopy = document.querySelector('input.url-page-for-copy');
        this.btnShareVK = document.querySelector('a.article-share--block__item_vk');
        this.btnShareTG = document.querySelector('a.article-share--block__item_tg');
        this.btnShareWA = document.querySelector('a.article-share--block__item_wa');
        this.btnShareOK = document.querySelector('a.article-share--block__item_ok');

        this.podcastInstance = new Swiper('.podcast-list-page .swiper-container', {
            slidesPerView: 'auto',
            spaceBetween: 18,
            freeMode: false,
            updateOnWindowResize: true,
            breakpoints: {
                992: {
                    spaceBetween: 43,
                }
            },
            navigation: {
                nextEl: $('.podcast-list-page .podcast-slider-container .btn-next').get(0),
                hiddenClass: 'deactivated',
                disabledClass: 'deactivated',
            }
        });

        this.items.forEach((item) => {
            const itemContentWrap = item.querySelector('.card-content-wrap') as HTMLElement;
            const itemContent = item.querySelector('.card-content') as HTMLElement;
            const itemContentHeight = itemContent.getBoundingClientRect().height
            itemContentWrap.style.height = `${itemContentHeight}px`
            item.addEventListener('click', () => {
                if (this.podcastInstance.allowTouchMove)
                    this.setActivePodcast(item)
            })
        })

        document.addEventListener('keyup', (event) => {
            if (event.key == "Escape") {
                this.closePodcast()
            }
        });
        this.closeButton.addEventListener('click', this.closePodcast.bind(this));


        if (window.location.hash.length > 0) {
            const item = document.querySelector(`[data-hash="${window.location.hash}"]`);
            if (item) {
                if (this.podcastInstance.allowTouchMove)
                    this.setActivePodcast(item)
            }
        }
    }

    renderCollapseText(text, textPart) {
        let textHtml = text;

        if (textPart.length > 0) {
            // textHtml = `${text}<span>...</span><div class="collapse-text__part">${textPart}</div><button class="collapse-text__button">Развернуть</button>`;
            textHtml = `<div class="collapse-text-v2__inner">${text}${textPart}</div><button class="collapse-text__button collapse-text-v2__button">Развернуть</button>`;
        }

        return `<div class="collapse-text collapse-text-v2">${textHtml}</div>`;
    }

    setContent(item) {
        const itemUrl = window.location.protocol + '//' + window.location.hostname + window.location.pathname + item.dataset.hash;

        this.contentTitle.innerHTML = this.sectionsData[item.dataset.slideId].name
        this.contentDesc.innerHTML = this.renderCollapseText(
            this.sectionsData[item.dataset.slideId].desc,
            this.sectionsData[item.dataset.slideId].desc_part
        );
        this.inputUrlCopy.value = itemUrl;
        this.btnShareVK.href = `https://vk.com/share.php?url=${itemUrl}&title=${this.sectionsData[item.dataset.slideId].name}`;
        this.btnShareTG.href = `https://t.me/share/url?url=${itemUrl}&text=${this.sectionsData[item.dataset.slideId].name}`;
        this.btnShareWA.href = `whatsapp://send?text=${itemUrl}`;
        this.btnShareOK.href = `https://connect.ok.ru/offer?url=${itemUrl}&title=${this.sectionsData[item.dataset.slideId].name}`;
    }

    closePodcast() {
        this.podcastInstance.allowTouchMove = true;
        this.closeButton.classList.remove('_active')

        this.content.classList.remove('_showed')

        if (window.innerWidth <= 567) {
            $(this.content).hide(300)
        }
        this.infoContainer.style.minHeight = `auto`;

        this.playlistContainer.innerHTML = '';
        this.inputUrlCopy.value = '';
        this.btnShareVK.href = '';
        this.btnShareTG.href = '';
        this.btnShareWA.href = '';
        this.btnShareOK.href = '';
        const item = document.querySelector('.podcast_active') as HTMLElement;
        this.items.forEach(item => {
            item.classList.remove('podcast_active')
            item.classList.remove('podcast_out')
        })

        $('.wrap-best-podcasts, .b-listen-recommend').show()
        new Animate({
            duration: 100,
            timing(timeFraction) {
                return Math.pow(timeFraction, 2)
            },
            draw: (progress) => {
                const curr = this.getMaxImageContainer();
                const diff = curr - 255;
                item.style.width = `${curr - (progress * diff)}px`;
            },
            onEnd: () => {
                this.rollbackCurrent(item, 0, () => {
                })
            }
        })

    }

    /* максимальная ширина картинки с учетом контейнера*/
    getMaxImageContainer() {
        let maxWidth = this.parentContainer.getBoundingClientRect().width - (21 * 2);
        return maxWidth <= 426 ? maxWidth : 426
    }

    getHeight(container) {
        return container.getBoundingClientRect().height;
    }

    setActivePodcast(item) {
        item.classList.add('podcast_active');
        this.closeButton.classList.add('_active');
        this.setContent(item);

        // реднер плейлиста
        this.renderPlaylist(item.dataset.slideId);

        // Выставляем высоту контейнера (фикс absolute)
        const infoContainerH = this.getHeight(this.infoContainer);
        const contentH = this.getHeight(this.content);
        const finalH = infoContainerH > contentH ? infoContainerH : contentH;
        this.infoContainer.style.minHeight = `${finalH + 50}px`;

        this.items.forEach(item => {
            if (!item.classList.contains('podcast_active')) {
                item.classList.add('podcast_out')
            }
        })

        this.podcastInstance.allowTouchMove = false;

        new Animate({
            duration: 100,
            timing(timeFraction) {
                return Math.pow(timeFraction, 2)
            },
            draw: (progress) => {
                const curr = 255;
                const diff = this.getMaxImageContainer() - curr;
                item.style.width = `${curr + (progress * diff)}px`;
            },
            onEnd: () => {
                const parentX = this.getX(this.parentContainer) + 21;
                const itemX = this.getX(item);
                const toX = parentX - itemX
                this.rollbackCurrent(item, toX, () => {
                    $(this.content).show(100, ()=> {
                        this.content.classList.add('_showed')
                    })

                    $('.wrap-best-podcasts, .b-listen-recommend').hide(100)
                })
            }
        })
    }

    rollbackCurrent(item, toX, onEnd) {
        new Animate({
            duration: 300,
            timing(timeFraction) {
                return Math.pow(timeFraction, 2)
            },
            draw(progress) {
                item.style.transform = `translateX(${progress * toX}px)`;
            },
            onEnd: () => {
                if (typeof onEnd !== 'undefined') onEnd();
            }
        });
    }

    getX = (container) => {
        return container.getBoundingClientRect().x
    }

    renderPlaylist(index) {

        this.playlistContainer.innerHTML = '';
        this.sectionsData[index].elements.forEach((item, index) => {
            this.playlistContainer.append(this.renderTrack(index, item))
        })

        Array.from(document.querySelectorAll('.js-play-audio')).forEach((item, index) => {
            // @ts-ignore
            item.dataset.trackId = index
        })
    }

    renderTrack(index, item) {
        const container = document.createElement('div');
        container.classList.add('podcast-playlist--item');
        container.classList.add('js-play-audio');
        container.dataset.trackId = String((index + 1) + 100);
        const string = `<div class="podcast-playlist--num">${index + 1}</div>
                        <div class="podcast-playlist--info">
                            <div class="podcast-playlist--title">${item.NAME}</div>
                            <div class="podcast-playlist--desc">${item.PREVIEW_TEXT}</div>
                        </div>
                        <div class="podcast-playlist--date">${item.DATE_FORMAT}</div>
                        <input type="hidden" class="btn-download" href="${item.AUDIO_SRC}">
                        <input type="hidden" class="img-src" href="${item.COVER}">
                        <div class="podcast-playlist--duration">${item.LENGTH}</div>`;

        container.innerHTML = string;

        return container;
    }
}

export default PodcastAudioPlayer;
